import { BarChart3, Briefcase, FileText, Landmark, MessagesSquare, PiggyBank, Receipt, Store, Target, User } from 'lucide-react';
import { STATUS as INVOICE_STATUS } from '@/components/invoices/invoiceFormat';
import { STAGE_TONE } from '@/components/leads/leadConstants';
import { statusLabel, statusStyle } from '@/lib/jobStatus';

export const TYPE_ICON = {
  jobs: Briefcase, estimates: FileText, invoices: Receipt, leads: Target, permits: Landmark, relay: MessagesSquare,
  budgets: PiggyBank, team: User, vendors: Store, reports: BarChart3,
};

const NEUTRAL = 'bg-slate-100 text-slate-600';

// A row's status pill, toned the way its own page tones it.
export function badgeOf(type, row) {
  if (!row.badge) return null;
  if (type === 'jobs') return { text: statusLabel(row.badge), cls: statusStyle(row.badge) };
  if (type === 'invoices' && INVOICE_STATUS[row.badge]) return { text: INVOICE_STATUS[row.badge].label, cls: `border ${INVOICE_STATUS[row.badge].cls}` };
  if (type === 'leads') return { text: row.badge, cls: `border ${STAGE_TONE[row.tone] || STAGE_TONE.new}` };
  return { text: String(row.badge).replace(/_/g, ' '), cls: NEUTRAL };
}
